import { useUserStore } from '@/stores/user';

export function getPersistScope(): string {
    return String(useUserStore().id);
}

export function getScopedPersistKey(baseKey: string): string {
    return `${baseKey}:${getPersistScope()}`;
}

type PersistPanelStore = {
    hiddenFilters?: string[];
    filterOrder?: string[];
    hiddenColumns?: string[];
    availableFilters?: { key: string }[];
    availableColumns?: { key?: string | number }[];
};

export function sanitizePagePersistState(store: PersistPanelStore): void {
    const filterKeys = new Set(store.availableFilters?.map((filter) => filter.key) ?? []);

    if (Array.isArray(store.hiddenFilters)) {
        store.hiddenFilters = store.hiddenFilters.filter((key) => filterKeys.has(key));
    }

    if (Array.isArray(store.filterOrder)) {
        store.filterOrder = store.filterOrder.filter((key) => filterKeys.has(key));
    }

    const columnKeys = new Set(
        store.availableColumns?.map((column) => column.key).filter((key): key is string => typeof key === 'string' && key.length > 0) ?? []
    );

    if (Array.isArray(store.hiddenColumns) && columnKeys.size > 0) {
        store.hiddenColumns = store.hiddenColumns.filter((key) => columnKeys.has(key));
    }
}
